const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div
  class="demo-container c-comment"
  style="max-width: 40rem; margin: 0 auto; padding: 0 1.25rem"
>
  <div class="o-rhythm c-comment__content o-rhythm--condensed">
    <h1>Heading Level 1</h1>
    <h2>Heading Level 2</h2>
    <h3>Heading Level 3</h3>
    <h4>Heading Level 4</h4>
    <h5>Heading Level 5</h5>
    <h6>Heading Level 6</h6>
    <p>
      This is a paragraph. It contains some <em>italic text</em>, some
      <strong>bold text</strong>, some
      <em><strong>bold and italic text</strong></em
      >, and some inline <code>code</code>, and a
      <a href="https://example.com">link</a>.
    </p>
    <pre
      class="language-css"
    ><code class="language-css">.code-block { color: hotpink; }</code></pre>
    <blockquote>
      <p>Here’s a blockquote</p>
      <cite>with a citation</cite>
    </blockquote>
    <ul>
      <li>Alpha</li>
      <li>
        Beta
        <ul>
          <li>Beta A</li>
          <li>Beta B</li>
        </ul>
      </li>
      <li>Gamma</li>
    </ul>
    <ol>
      <li>Alpha</li>
      <li>
        Beta
        <ol>
          <li>Beta A</li>
          <li>Beta B</li>
        </ol>
      </li>
      <li>Gamma</li>
    </ol>
    <table>
      <thead>
        <tr>
          <th>First Header</th>
          <th>Second Header</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Content Cell</td>
          <td>Content Cell</td>
        </tr>
        <tr>
          <td>Content Cell</td>
          <td>Content Cell</td>
        </tr>
      </tbody>
    </table>
    <p>Here’s an image:</p>
    <p>
      <img
        src="https://api.lorem.space/image/movie?w=150&amp;h=220&amp;t=1"
        alt="Movie Poster"
      />
    </p>
    <p>And to wrap it all up, here’s a horizontal rule:</p>
    <hr />
  </div>
</div>
`);
            }

            getTemplateName() {
                return `259bf99c5e626f0a678c98f5b074f7afd872401e591119f4355ab0e77fa9a4df`;
            }

            getSourceContext() {
                return new this.Source(``, `259bf99c5e626f0a678c98f5b074f7afd872401e591119f4355ab0e77fa9a4df`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '259bf99c5e626f0a678c98f5b074f7afd872401e591119f4355ab0e77fa9a4df');

let template = env.loadTemplate('259bf99c5e626f0a678c98f5b074f7afd872401e591119f4355ab0e77fa9a4df');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/compare-comment.twig", args: context }
     );
     return rendered;;
};